export default { camelToTitleCase };

function camelToTitleCase(value) {
    if (value === null || value === '') {
        return value;
    }

    return value
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
        .replace(/^./, s => s.toUpperCase());
}

export function isNullOrWhiteSpace(value) {
    return value == null || (typeof value === 'string' && value.trim() == "");
}
